import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery';

const projectApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'projectsApi',
  tagTypes: ['Project', 'ProjectList', 'ProjectDetail'],
  endpoints: () => ({}),
});

export default projectApi;
